<script lang="ts" setup>
import AppHeader from '~/widgets/layout/AppHeader.vue'
import StickyMenu from '~/widgets/layout/StickyMenu.vue'
import AppFooter from '~/widgets/layout/AppFooter.vue'
import Preloader from '~/components/ui/preloader/Preloader.vue'
import getInitialData from '~/composables/initial-data'

await getInitialData()
</script>

<template>
  <AppHeader />
  <main class="main">
    <slot />
  </main>
  <ClientOnly>
    <StickyMenu />
  </ClientOnly>
  <div id="main-under-content"></div>
  <AppFooter />
  <Preloader />
</template>

<style lang="scss" scoped>
.main {
  padding-top: 128px;
  background-color: #ffffff;
  padding-bottom: 40px;
}
</style>
